import React from 'react';

import Forgot from '../../components/Auth/Forgot';

const ForgotPassword = () => (
  <Forgot />
);

export default ForgotPassword;